import { useQuery } from "@tanstack/react-query";
import { OrderFragment } from "./fragments/order";
import { useCustomerSession } from "./use-customer-session";
import { gqlReq } from "~/libs/gql";
import { useVenueId } from "~/store";
import { GetCurrentCustomerOrdersDocument } from "~/types/__generated/gql/graphql";

void (
	/* GraphQL */ `
		query GetCurrentCustomerOrders {
			getCurrentCustomerOrders {
				...OrderFragment
			}
		}
		${OrderFragment}
	`
);

export const useCustomerOrders = () => {
	const venueId = useVenueId();
	const { customer } = useCustomerSession();
	return useQuery({
		queryKey: ["customer", venueId, "orders", customer?._id],
		enabled: !!customer,
		staleTime: 0,
		refetchOnMount: "always",
		queryFn: ({ signal }) =>
			gqlReq({ document: GetCurrentCustomerOrdersDocument, signal }),
	});
};
